import { createLink, type LinkComponent } from "@tanstack/react-router";
import { NavLinkItem } from "../NavLinkItem/NavLinkItem";

const LinkedNavLinkComponent = createLink(NavLinkItem);

export const NavLink: LinkComponent<typeof NavLinkItem> = (props) => {
  return (
    <LinkedNavLinkComponent
      preload="intent"
      activeProps={() => ({ selected: true })}
      {...props}
    />
  );
};
